import { CONFIG } from 'config/tournaments';

export const STATUSES = {
  running: 'RUNNING',
  comingSoon: 'COMING_SOON',
  ended: 'ENDED',
};

export const getType = {
  [STATUSES.running]: 'running',
  [STATUSES.comingSoon]: 'comingSoon',
  [STATUSES.ended]: 'ended',
};

const categoryConfigs = {
  running: {
    title: 'Running',
    color: '#8ACB00',
  },
  comingSoon: {
    title: 'Coming soon',
    color: '#8ACB00',
  },
  ended: {
    title: 'Ended',
    color: '#EBEBEC',
  },
};

export const getCategory = (type) => categoryConfigs[type];

export const getGameUrl = (user_id, email) => {
  const { game_url, game_code } = CONFIG[process.env.REACT_APP_VERSION];

  return `${game_url}?user_id=${user_id}&game_code=${game_code}&email=${email}`;
};
